import Websocket from '@/utils/websocket'
const state = {
  websocket: null,
  deviceConfig: { timestamp: new Date() },
  deviceSetting: { timestamp: new Date() },
  protocolConfigSetting: { timestamp: new Date() },
  deviceStore: { timestamp: new Date() },
  remoteOpen: { timestamp: new Date() },
  deviceStatus: { timestamp: new Date() },
  getAllUser: { timestamp: new Date() },
  sendAepDeviceParam: { timestamp: new Date() },
  sendAepDeviceRealtimeLog: { timestamp: new Date() },
  timeLog: { timestamp: new Date() },
  aiCameraData: { timestamp: new Date() },
  agreementException: { timestamp: new Date() },
  lrpEquipmentTimeLog: { timestamp: new Date() },
  cameraChannel: { timestamp: new Date() },
  aiCameraTimeLog: { timestamp: new Date() },
  locationCoordinateSetting: { timestamp: new Date() },
  deviceGPSParam: { timestamp: new Date() },
  aiBoxAlarmRecord: { timestamp: new Date() }
}

const mutations = {
  SET_WEBSOCET_INSTANCE: (state, websocket) => {
    state.websocket = websocket
  },
  SET_DEVICE_CONFIG: (state, deviceConfig) => {
    state.deviceConfig = deviceConfig
  },
  SET_DEVICE_SETTING: (state, deviceSetting) => {
    state.deviceSetting = deviceSetting
  },
  SET_PROTOCOL_CONFIG_SETTING: (state, protocolConfigSetting) => {
    state.protocolConfigSetting = protocolConfigSetting
  },
  SET_DEVICE_STORE: (state, deviceStore) => {
    state.deviceStore = deviceStore
  },
  SET_REMOTE_OPEN: (state, remoteOpen) => {
    state.remoteOpen = remoteOpen
  },
  SET_DEVICE_STATUS: (state, deviceStatus) => {
    state.deviceStatus = deviceStatus
  },
  SET_GET_ALL_USER_ID: (state, getAllUser) => {
    state.getAllUser = getAllUser
  },
  SET_AEP_DEVICE_PARAM: (state, sendAepDeviceParam) => {
    state.sendAepDeviceParam = sendAepDeviceParam
  },
  SET_AEP_DEVICE_REALTIME_LOG: (state, sendAepDeviceRealtimeLog) => {
    state.sendAepDeviceRealtimeLog = sendAepDeviceRealtimeLog
  },
  SET_TIME_LOG: (state, timeLog) => {
    state.timeLog = timeLog
  },
  SET_AI_CAMERA_TIME_LOG: (state, aiCameraTimeLog) => {
    state.aiCameraTimeLog = aiCameraTimeLog
  },
  SET_AI_CAMERA_DATA: (state, aiCameraData) => {
    state.aiCameraData = aiCameraData
  },
  SET_AGREEMENT_EXCEPTION: (state, agreementException) => {
    state.agreementException = agreementException
  },
  SET_LRP_EQUIPMENT_TIME_LOG: (state, lrpEquipmentTimeLog) => {
    state.lrpEquipmentTimeLog = lrpEquipmentTimeLog
  },
  SET_GET_CAMERA_CHANNEL: (state, cameraChannel) => {
    state.cameraChannel = cameraChannel
  },
  SET_LOCATION_COORDINATE_SETTING: (state, locationCoordinateSetting) => {
    state.locationCoordinateSetting = locationCoordinateSetting
  },
  SET_DEVICE_GPS_PARAM: (state, deviceGPSParam) => {
    state.deviceGPSParam = deviceGPSParam
  },
  SET_AI_BOX_ALARM_RECORD_TIME_LOG: (state, aiBoxAlarmRecord) => {
    state.aiBoxAlarmRecord = aiBoxAlarmRecord
  }
}

const actions = {
  initSocket({ commit, state, dispatch, rootState }, payload) {
    if (!state.websocket) {
      commit('SET_WEBSOCET_INSTANCE', Websocket())
      state.websocket.connect(() => {
        state.websocket.subscribe('/user/queue/deviceConfig', (data) => {
          data.timestamp = Date.now()
          commit('SET_DEVICE_CONFIG', data)
        })
        state.websocket.subscribe('/user/queue/deviceSetting', (data) => {
          console.log(data)
          data.timestamp = Date.now()
          commit('SET_DEVICE_SETTING', data)
        })
        state.websocket.subscribe(
          '/user/queue/protocolConfigSetting',
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_PROTOCOL_CONFIG_SETTING', data)
          }
        )
        state.websocket.subscribe('/user/queue/deviceStore', (data) => {
          data.timestamp = Date.now()
          commit('SET_DEVICE_STORE', data)
        })
        state.websocket.subscribe('/user/queue/remoteOpen', (data) => {
          data.timestamp = Date.now()
          commit('SET_REMOTE_OPEN', data)
        })
        state.websocket.subscribe(
          `/topic/${rootState.user.userInfo.orgId}`,
          (data) => {
            data.data.timestamp = Date.now()
            if (data.messageType === 'deviceStatus') {
              commit('SET_DEVICE_STATUS', data)
            }
          }
        )
        state.websocket.subscribe(`/user/queue/getAllUserID`, (data) => {
          data.timestamp = Date.now()
          commit('SET_GET_ALL_USER_ID', data)
        })
        state.websocket.subscribe(
          `/topic/${rootState.user.projectItem.projectId}/sendAepDeviceRealtimeLog`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_AEP_DEVICE_REALTIME_LOG', data)
          }
        )
        state.websocket.subscribe(
          `/topic/${rootState.user.projectItem.projectId}/sendAepDeviceParam`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_AEP_DEVICE_PARAM', data)
          }
        )
        state.websocket.subscribe(
          `/topic/${rootState.user.projectItem.projectId}/timeLog`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_TIME_LOG', data)
          }
        )
        state.websocket.subscribe(
          `/topic/${rootState.user.projectItem.projectId}/aiCameraTimeLog`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_AI_CAMERA_TIME_LOG', data)
          }
        )
        state.websocket.subscribe(
          `/topic/${rootState.user.projectItem.projectId}/aiCameraData`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_AI_CAMERA_DATA', data)
          }
        )
        state.websocket.subscribe(
          `/user/queue/sendGetCameraChannel`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_GET_CAMERA_CHANNEL', data)
          }
        )
        if (rootState.user.agreementList) {
          rootState.user.agreementList.forEach((element) => {
            state.websocket.subscribe(
              `/topic/${rootState.user.projectItem.projectId}/${element.agreementCode}/agreementException`,
              (data) => {
                data.timestamp = Date.now()
                commit('SET_AGREEMENT_EXCEPTION', data)
              }
            )
          })
        }
        state.websocket.subscribe(
          `/topic/${rootState.user.projectItem.projectId}/sendLrpEquipmentTimeLog`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_LRP_EQUIPMENT_TIME_LOG', data)
          }
        )
        state.websocket.subscribe(
          `/topic/${rootState.user.projectItem.projectId}/aiBoxAlarmRecord`,
          (data) => {
            console.log(data)
            data.timestamp = Date.now()
            commit('SET_AI_BOX_ALARM_RECORD_TIME_LOG', data)
          }
        )
        state.websocket.subscribe(
          `/user/queue/locationCoordinateSetting`,
          (data) => {
            console.log('locationCoordinateSetting', data)
            data.timestamp = Date.now()
            commit('SET_LOCATION_COORDINATE_SETTING', data)
          }
        )
        state.websocket.subscribe(`/user/queue/deviceGPS`, (data) => {
          console.log('SET_DEVICE_GPS_PARAM', data)
          data.timestamp = Date.now()
          commit('SET_DEVICE_GPS_PARAM', data)
        })
      })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
